<template>
  <div data-test="information-card" class="information-card">
    <div
      v-if="heading || !readOnly"
      :class="[
        'information-card__heading-wrapper',
        'display--d2--semibold',
        'margin-bottom--7'
      ]"
    >
      <div class="information-card__heading">
        {{ heading }}
      </div>
      <div v-if="!readOnly" class="information-card__button-wrapper">
        <USButton
          is="button"
          type="inline"
          icon="pencil"
          class="information-card__button"
          @click="$emit('edit')"
        />
      </div>
    </div>
    <div class="information-card__slot-wrapper">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import USButton from '@base/components/USButton/USButton.vue'

export default defineComponent({
  name: 'InformationCard',
  components: { USButton },
  props: {
    heading: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  emits: ['edit']
})
</script>

<style lang="scss" scoped>
.information-card {
  border: var(--line-weight--light) solid var(--color--neutral-a4);
  border-radius: var(--border-radius--small);
  padding: var(--spacing--7) var(--spacing--6);

  &__heading-wrapper {
    display: flex;
    justify-content: space-between;
  }

  &__button-wrapper {
    display: flex;
  }
}
</style>
